export enum NoteType {
    Suppliers = 'suppliers',
    Customers = 'customers',
    Contacts = 'contacts',
    Products = 'products',
}
